import { render, staticRenderFns } from "./PlanAdvisor.vue?vue&type=template&id=2224577a&"
import script from "./PlanAdvisor.vue?vue&type=script&lang=js&"
export * from "./PlanAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports